import { Box, Link } from '@bcp-nextgen-dx-component-factory/design-system';
import { ArrowRight } from '@bcp-nextgen-dx-component-factory/icons-accolade';
import { UIHelper } from '@helpers';

import { AppComposableTypography } from '../_cf';
import { LanguageSelection } from '../languageSelection';
import { Divider } from './divider';
import { FooterProps } from './footer';
import { resources, useFooterHelper } from './footer.helper';

export const FooterDesktop = ({ styles }: FooterProps) => {
	const { t, translationKey, showText, showLink } = useFooterHelper();

	return (
		<>
			<Divider />
			<Box
				styles={{
					flexDirection: 'column',
					alignItems: 'center',
					background: '#FFFFFF',
					padding: UIHelper.rem(24, 24, 30, 24),
					gap: UIHelper.rem(24),
					...styles,
				}}
			>
				{(showText || showLink) && (
					<Box
						styles={{
							maxWidth: UIHelper.rem(550),
							justifyContent: 'center',
							textAlign: 'center',
							gap: UIHelper.rem(8),
							flexWrap: 'wrap',
						}}
					>
						{showText && (
							<AppComposableTypography
								appearance="body-100-02"
								colorToken="secondary-light"
								text={t(resources[translationKey].text)}
							/>
						)}

						{showLink && (
							<Link
								label={t(resources[translationKey].link.text)}
								link={t(resources[translationKey].link.url)}
								rightIcon={ArrowRight.Outline}
								target="_blank"
								size="large"
							/>
						)}
					</Box>
				)}

				<LanguageSelection size="regular" />
			</Box>
		</>
	);
};
